var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleGreen = function SvgCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30A46C",
    fillRule: "evenodd",
    d: "M7.333 1.333a6 6 0 1 0 0 12 6 6 0 0 0 0-12M0 7.333a7.333 7.333 0 1 1 14.667 0A7.333 7.333 0 0 1 0 7.333m10.805-2.471c.26.26.26.682 0 .943l-4 4a.667.667 0 0 1-.943 0l-2-2a.667.667 0 1 1 .943-.943L6.333 8.39l3.529-3.53c.26-.26.682-.26.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircleGreen;